// A3 Header
export const APP_HEADER_HEIGHT = 59;

// A3 Footer
export const APP_FOOTER_HEIGHT = 30;
export const APP_FOOTER_TRIAL_EXTRA_HEIGHT = 50;

// "Lab Features" button
export const IS_BETA_FEATURES_ENABLED = true;

// Dataset menu
export const MAX_NAME_LENGTH_BEFORE_TRUNCATE = 24;
export const MAX_FAVORITES_IN_LIST = 3;
export const MAX_RECENT_IN_LIST = 3;

// Theme (useAppTheme.ts)
export const LOCAL_STORAGE_THEME_KEY = 'currentDarkMode';
export const THEME_EVENT = 'theme-change';

// App Settings (useAppSettings.ts)
// Setting Menu - Default Values
export type WeekStartsOnDay = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const DEFAULT_WEEK_STARTS_ON: WeekStartsOnDay = 1;

export const HISTORY_DATA_FETCH_LIMITS = [200, 100, 50, 10] as const;
export type HistoryDataFetchLimit = (typeof HISTORY_DATA_FETCH_LIMITS)[number];
export const DEFAULT_HISTORY_DATA_FETCH_LIMIT: HistoryDataFetchLimit = 200;

export const LOCAL_STORAGE_DATEFORMAT_KEY = 'a3-azure-dateformat';
export const LOCAL_STORAGE_LOCALE_KEY = 'currentLocale';
export const LOCAL_STORAGE_WEEK_STARTS_ON_KEY = 'a3-azure-week-starts-on';
export const LOCAL_STORAGE_HISTORY_DATA_FETCH_LIMIT_KEY = 'a3-azure-history-data-limit';

// Landing Page - Datasets Table
export const MAX_NUMBER_OF_ROWS = 10;
